import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function BBQPartyMay2024({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div className="Solera__Cont">
            <FiX className="Solera__Close" onClick={onClose} />
          </div>

          <div className="Exoc-Name">BBQ PARTY MAY 2024</div>
          {/* <div className="Exco-Tittle">President</div> */}
          <br />

          {/* <div className="NO-Events">BBQ PARTY 2022</div> */}
          <br />
          <div >
          <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/1.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/2.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/3.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/4.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/5.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/6.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/7.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/8.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/9.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/10.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/11.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/12.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/Part2024/13.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                
                 
                </div>
              </div>
         
         
         
            
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}



export default BBQPartyMay2024;
